import type { WalletRecipientView } from '@/api/address-book-bff/types';
import { Avatar } from '@/design-system';

import { getRecipientName } from './recipient-name';
import { AvatarImage } from './send-recipient-combobox.styled';

export const SendRecipientAvatar = ({ recipient }: { recipient: WalletRecipientView }) => {
  const name = getRecipientName(recipient);

  return (
    <Avatar
      size="sm"
      color="green"
      variant="subtle"
      initials={name}
      type={recipient.iconUrl ? 'icon' : 'initials'}
      icon={recipient.iconUrl ? <AvatarImage src={recipient.iconUrl} alt={name} /> : undefined}
    />
  );
};
